module.exports = __webpack_public_path__ + "img/662a2f294f564be7aba4ce86ef6f5a5e.112a14d5.png";